
import Vue from "vue";
import action from "@/components/ActionBarCom.vue";
import pageCom from "@/components/PageCom.vue";
import dialogCom from "@/components/ModelCom.vue";
import DeviceRequestBill from "@/assets/js/Bill/DeviceRequestBill";
import Utils from "@/assets/js/Utils";
import HttpUtil from "@/assets/js/HttpUtil";
import Urls from "@/assets/js/Urls";
export default Vue.extend({
  data() {
    return {
      total: 0,
      pageSize: 20,
      items: [] as any,
      currentPage: 1,
      current: null as any,
      currentSid: null as any,
      title: "",
      CSID: "",
      alinks: [] as any,
      texts: [] as any,
      alarmTypes: [] as any[],
      form: {} as any,
      broads: [] as any[],
      subCurrent: null as any,
      subConfigCurrent: null as any,
      configs: [] as any,
      cform: {} as any,
      showTime: true,
      typeSid: null as any,
    };
  },
  components: { action, pageCom, dialogCom },
  mounted() {
    this.getTypeSid();
    this.CSID = Utils.getCurrentSid(this.$route.path);
    if (this.CSID == "6") {
      this.showTime = true;
    }
    this.getList();
    this.getTexts();
    this.getAlarmTypes();
    this.getBroads();
  },
  methods: {
    getTypeSid() {
      const path: any = this.$route.path;
      if (path.toLocaleLowerCase().indexOf("/home/dustcar") != -1) {
        this.typeSid = "c05";
      }
    },
    getSplitTime(time: any) {
      try {
        return time.split(" ")[1];
      } catch {
        return "";
      }
    },
    currentChangeSubConfig(val: any) {
      this.subConfigCurrent = val;
    },
    async configClick(data: any) {
      this.current = data;
      this.currentSid = this.current.sid;
      const ret: any = await HttpUtil.XCHttpPost(
        Urls.GetDeviceAlarmConfig,
        this.current.sid,
        true,
        false
      );
      this.configs = ret.alarmConfigs;
      const dialog: any = this.$refs.cDialog;
      dialog.show();
    },
    closeCDialog() {
      const dialog: any = this.$refs.cDialog;
      dialog.hiden();
    },
    closeConfig() {
      const dialog: any = this.$refs.addConfigDialog;
      dialog.hiden();
    },
    async copyConfig() {
      if (!this.current) {
        throw "请选择一条数据";
      }
      await HttpUtil.XCHttpPost(Urls.CopyDeviceAConfig, this.current.sid, true, false);
      this.closeCDialog();
      this.closeConfig();
    },
    addConfig() {
      const dialog: any = this.$refs.addConfigDialog;
      dialog.show();
    },
    async delConfig() {
      if (!this.subConfigCurrent) {
        throw "请选择一条数据";
      }
      const index = this.configs.findIndex(
        (item: any) => item.sid === this.subConfigCurrent.sid
      );
      if (index !== -1) {
        this.configs.splice(index, 1);
      }
      const req = {
        deviceSid: this.current.sid,
        alarmConfigs: this.configs,
      };
      await HttpUtil.XCHttpPost(Urls.UpdateDeviceAConfig, req, true, false);
      this.closeCDialog();
      this.closeConfig();
    },
    async onAddConfigSubmit() {
      this.configs.push(this.cform);
      const req = {
        deviceSid: this.current.sid,
        alarmConfigs: this.configs,
      };
      await HttpUtil.XCHttpPost(Urls.UpdateDeviceAConfig, req, true, false);
      this.closeCDialog();
      this.closeConfig();
    },
    async getTexts() {
      const ret: any = await DeviceRequestBill.GetTexts(null, 1, 1000);
      this.texts = ret.data;
    },
    async getBroads() {
      const ret: any = await DeviceRequestBill.GetBroads(null, 1, 1000);
      this.broads = ret.data;
      console.log(this.broads, ret, "tetttt");
    },
    async getAlarmTypes() {
      const ret: any = await HttpUtil.XCHttpPost(
        Urls.GetAlarmTypes,
        this.CSID,
        true,
        false
      );
      this.alarmTypes = ret;
    },
    getText(sid: string) {
      const exsit: any = this.texts.filter((r: any) => r.sid == sid);
      if (exsit && exsit.length >= 0) {
        return exsit[0].text;
      }
    },
    closeLink() {
      const dialog: any = this.$refs.addLinkDialog;
      dialog.hiden();
    },
    closeDialog() {
      const dialog: any = this.$refs.dialog;
      dialog.hiden();
    },
    addLink() {
      const dialog: any = this.$refs.addLinkDialog;
      dialog.show();
    },
    async delLink() {
      if (!this.subCurrent) {
        throw "请选择一条数据";
      }
      const index = this.alinks.findIndex((item) => item.sid === this.subCurrent.sid);
      if (index !== -1) {
        this.alinks.splice(index, 1);
      }
      const req = {
        deviceSid: this.current.sid,
        alarmLinks: this.alinks,
      };
      await HttpUtil.XCHttpPost(Urls.UpdateDeviceALink, req, true, false);
      this.closeLink();
      this.closeDialog();
    },
    async onAddLinkSubmit() {
      this.alinks.push(this.form);
      const req = {
        deviceSid: this.current.sid,
        alarmLinks: this.alinks,
      };
      await HttpUtil.XCHttpPost(Urls.UpdateDeviceALink, req, true, false);
      this.closeLink();
      this.closeDialog();
    },
    async getList() {
      const actionBar: any = this.$refs.action;
      const content = actionBar.getSearch();
      const ret = await DeviceRequestBill.GetDeviceList(
        this.CSID,
        content,
        this.currentPage,
        this.pageSize
      );
      if (this.typeSid == null) {
        this.items = ret.data;
      } else {
        this.items = ret.data.filter((x: any) => x.deviceTypeSid == this.typeSid);
      }
      this.total = ret.total;
    },
    currentChange(val: any) {
      this.current = val;
    },
    currentChangeSub(val: any) {
      this.subCurrent = val;
    },
    itemClick(item: any) {
      this.currentSid = item.sid;
      this.current = item;
      this.modify();
    },
    async modify() {
      if (!this.current) {
        throw "请选择一条数据";
      }
      const ret: any = await HttpUtil.XCHttpPost(
        Urls.GetDeviceAlarmConfig,
        this.current.sid,
        true,
        false
      );
      this.alinks = ret.alarmLinks;
      const dialog: any = this.$refs.dialog;
      dialog.show();
    },
    change(val: number, size: number) {
      this.currentPage = val;
      this.pageSize = size;
      this.getList();
    },
  },
});
